import {Component, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {DashboardService} from '../../../../service/events/dashboard.service';
import {TrabajadoresApiService} from '../../../../service/api/trabajadores-api.service';
import {RequestHandler} from '../../../../service/OffService/request-handler';
import {RequestButtonTypes} from '../../../../common/components/request-button/request-button.component';
import {BaseView} from '../../../base-view';
import {environment} from '../../../../../environments/environment';
import moment from 'moment';
import { Filtering } from 'src/app/service/filtering/filtering';
import { StorageManager } from 'src/app/common/storage-manager.class';
import { Utils } from 'src/app/common/utils';
import { TrabajadoresService } from 'src/app/service/trabajadores/trabajadores.service';
import { MessageService, TreeNode } from 'primeng/api';
import { firstValueFrom } from 'rxjs';

import { MantenimientoModel } from 'src/app/models/trabajadores/mantenimiento.model';
import { ColInterface } from 'src/app/common/components/common-list-table/col.interface';
import { ColStylesInterface } from 'src/app/common/components/common-list-table/col-styles.interface';
import { CargoModel } from 'src/app/models/trabajadores/cargos.model';
import { TreeTableModule } from 'primeng/treetable';
import { Compradores } from 'src/app/models/ventas/compradores.model';
import { list } from 'src/app/common/classes/request-builder';
import { DropdownData, FormType } from '@fitogest/reactive-form-builder/interfaces';

import { MantenimientoCargoFormDefinition, MantenimientoCargoFormModel } from './mantenimiento-form/form-control/cargos-form-definition';
import { MantenimientoFormDefinition } from './mantenimiento-form/form-control/form-definition';
@Component({
    selector: 'app-mantenimiento',
    standalone: false,
    templateUrl: './mantenimiento.component.html',
    styleUrls: ['./mantenimiento.component.scss'],
    providers: [MessageService]
})
export class MantenimientoComponent extends BaseView<MantenimientoModel> implements OnInit {
    public serverUrl = environment.serverUrl;

    public form: MantenimientoFormDefinition | null = null;

    public cargoForm = new MantenimientoCargoFormDefinition();



    @ViewChild('table_cargos', {read: false, static: false}) table_cargos: TreeTableModule = new TreeTableModule();

    public appName = environment.appName;

    public activateREA = environment.features.activateREA;

    public applicationType = environment.features.applicationType;

    public currentUser = StorageManager.getUser();

    public showCostes = environment.features.showCostes;

    public showTrabajadoresCargos = environment.features.showTrabajadoresCargos;

    public showTrabajadoresFirma = environment.features.showTrabajadoresFirma;

    public aplicadorName = environment.features.aplicadorName;

    public addText = 'Añadir ' + this.aplicadorName;

    public showAplicadoresActivo = environment.features.showAplicadoresActivo;

    public filterAplicadoresByClient = environment.features.filterAplicadoresByClient;

    public trabajadoresAsUsuarios = environment.features.trabajadoresAsUsuarios;

    public showTrabajadoresCuadrillas = environment.features.showTrabajadoresCuadrillas;

    public showTrabajadoresNumSS = environment.features.showTrabajadoresNumSS;

    public showTrabajadoresMaquinaria = environment.features.showTrabajadoresMaquinaria;

    public canEditTrabajadores = environment.features.canEditTrabajadores;

    public showTrabajadoresClienteAsignado = environment.features.showTrabajadoresClienteAsignado;

    public clienteName = environment.features.clienteName;

    public hasClients = environment.features.hasClients;

    public userCanSeeClientes = this.hasClients &&
        (environment.features.userCanSeeClientes ? true : (StorageManager.getUser().rol === 'admin'));

    public showFotoTrajador = environment.features.showFotoTrajador;
 
    public titleActivo = environment.features.titleActivoMaqTra;

    public showTrabajadoresUserYPass = environment.features.showTrabajadoresUserYPass;

    public filter: Filtering<MantenimientoModel> = new Filtering<MantenimientoModel>();
    
    public getRequest: RequestHandler<MantenimientoModel[]> = this.trabajadoresApi.trabajadoresGET;

    public deleteRequest: RequestHandler<MantenimientoModel> = this.trabajadoresApi.trabajadoresDELETE;

    public getRequestCargos: RequestHandler<CargoModel[]> = this.trabajadoresApi.cargosGET;

    public comercios: DropdownData<Compradores> = list<Compradores>(['...', null]);

    public pathToForm = 'mantenimiento-form';

    public menuItemId = 'mantenimiento';

    public deleteRequestButtonType: RequestButtonTypes = RequestButtonTypes.DELETE;

    public override canShow: Record<string, boolean> = {};

    public override model = {} as MantenimientoModel;

    public modelCargos: MantenimientoCargoFormModel = {
        nombre: '',
        precio_hora: 0.0
    };

    public componentName = 'trabajadores';

    public propiedad = {
        selected: ''
    };

    public textoClienteAsignado = 
        this.clienteName + ' asignad' + 
            (this.clienteName.slice(-1) === 'a' ? 'a' : 'o');


    public cols: ColInterface[] = [
        {header: 'Usuario', field: 'username', visible: this.trabajadoresAsUsuarios},
        {header: 'Nombre', field: 'nombre'},
        {header: 'Primer Apellido', field: 'primer_apellido'},
        {header: 'Segundo Apellido', field: 'segundo_apellido'},
        // {header: 'Apellidos', field: 'apellidos'},
        {header: 'NIF', field: 'nif'},
        {header: 'Cuadrilla', field: 'nombre_cuadrilla', visible: this.showTrabajadoresCuadrillas},
        {header: 'Carnet', field: 'tipo_carnet'},
        {header: 'ROPO', field: 'ropo'},
        {header: 'F.\xa0Caducidad', field: 'fecha_cad'},
        {header: 'Máquina', field: 'maquinaria', visible: this.showTrabajadoresMaquinaria},
        {header: 'Ocupación', field: 'ocupacion', visible: (this.appName === 'naturfrut')},
        {header: 'Propiedad', field: 'propiedad', visible: (this.appName === 'agropecuariaramirogruas')},
        {header: this.titleActivo, field: 'activo', width: '60px', visible: this.showAplicadoresActivo},
        {header: this.textoClienteAsignado, field: 'cliente_nombre', visible: this.showTrabajadoresClienteAsignado},
        {header: 'Cargo', field: 'cargo', visible: this.showTrabajadoresCargos},
        {header: 'Empresa', field: 'empresa', visible: this.appName === 'avafitogest'},
    ];

    public colsCargos: ColInterface[] = [
        {header: 'Nombre', field: 'nombre'},
        {header: 'Precio', field: 'precio_hora', width: '80px'}
    ];

    public trabajadores: TreeNode<CargoModel>[] = [];

    public imagenAdjunto: string | null = '';


    constructor(
        public trabajadoresApi: TrabajadoresApiService,
        private readonly dashboard: DashboardService,
        private readonly router: Router,
        private readonly trabajadoresService: TrabajadoresService,
        private readonly messageService: MessageService,
    ) {
        super(dashboard, trabajadoresApi.trabajadoresGET, trabajadoresApi.trabajadoresDELETE);
    }

    ngOnInit() {
        this.dashboard.setSubmenuItem('_aplicadores', this.menuItemId);
        this.trabajadoresApi.cargosGET.toPromise()
            .then( trabajadores => {
                this.trabajadores = trabajadores as TreeNode<CargoModel>[];
                return;
            })
            .catch( error => {
                alert('Registro de cargo no se ha podido guardar ' + JSON.stringify(error) );
            });   
        this.initFilter();
        
        this.getRequest.response((trabajadores: MantenimientoModel[]) => {
            trabajadores.forEach(trabajador => {
                this.procesarApellidos(trabajador);
            });
        });
    }

    private procesarApellidos(trabajador: MantenimientoModel) {
        if (trabajador.apellidos && (!trabajador.primer_apellido || !trabajador.segundo_apellido)) {
            const apellidosNormalizados = trabajador.apellidos.trim().replace(/\s+/g, ' ');
            const primerEspacio = apellidosNormalizados.indexOf(' ');
            
            if (primerEspacio > 0) {
                trabajador.primer_apellido = apellidosNormalizados.substring(0, primerEspacio);
                trabajador.segundo_apellido = apellidosNormalizados.substring(primerEspacio + 1);
            } else {
                trabajador.primer_apellido = apellidosNormalizados;
                trabajador.segundo_apellido = '';
            }
        }
    }

    updateCargo( trabajador: MantenimientoModel ) {
        firstValueFrom(this.trabajadoresService.updateTrabajadores(trabajador, trabajador.id ?? ''))
            .then( () => {
                this.messageService.add({severity: 'warn', summary: 'Registro', detail: ' Registro actualizado correctamente'});
                return;
            })
            .catch( error => {
                alert('Registro de cargo no se ha podido guardar ' + JSON.stringify(error) );
            });    
        
    }
    
    deleteCargo( trabajador: MantenimientoModel) {
        firstValueFrom(this.trabajadoresService.deleteTrabajadores(trabajador.id ?? ''))
            .then( () => {
                this.messageService.add({severity: 'warn', summary: 'Registro', detail: ' Registro eliminado correctamente'});
                window.location.reload();
                return;
            })
            .catch( error => {
                alert('Registro de cargo no se ha podido eliminar ' + JSON.stringify(error) );
            });    
        
    }

    editCargo(index: number) {
        document?.getElementById('precioHora' + index )?.focus();    
    }

    insertarCargo() {
        this.trabajadoresApi.cargosPOST.perform(this.modelCargos as never);
        
        this.trabajadoresApi.cargosPOST.response(() => {
            this.trabajadoresApi.cargosPOST.unsuscribe();
            window.location.reload();
        });
    }

    public filtrarTrabajadores(event: Event){
        const input = event.target as HTMLInputElement;

        if (input.value === 'Propios') {
            this.propiedad.selected = 'Propios';
        }
        else if (input.value === 'Cliente'){
            this.propiedad.selected = 'Cliente';
        }
        else{
            this.propiedad.selected = 'Todos';
        }
        this.filter.filter();
    }// ();


    public globalConditionalStyle(value: string, col: ColInterface): ColStylesInterface {        
        if (col.field === 'fecha_cad') {
            const fecha = moment(value, 'DD/MM/YYYY');
            const tresMesesAntes = moment(value, 'DD/MM/YYYY').subtract(3, 'months');
            const unAñoAntes = moment(value, 'DD/MM/YYYY').subtract(1, 'year');
            const hoy = moment(moment().format('MM-DD-YYYY' + ' 00:00:00'));

            const fechaAviso = this.appName === 'ava' ? unAñoAntes : tresMesesAntes;

            if (hoy.isSameOrAfter(fechaAviso) && hoy.isSameOrBefore(fecha)) {
                return {
                    textAlign: 'center',
                    rowStyle: {
                        backgroundColor: '#ff9a02',
                    }
                };
            } else if (hoy.isAfter(fecha)) {
                return {
                    textAlign: 'center',
                    rowStyle: {
                        backgroundColor: '#f44242',
                    }
                };
            }
        }
       
        if (Utils.isNumber(value) || col.field === 'ropo' ) {
            return {
                textAlign: 'center',
                paddingRight: '40px'
            };
        }
        return{ textAlign: 'center'};

    }

    public globalVisualTransform(value: string, col: ColInterface): string {
        if (col.field === 'activo'){
            return ([1, true, '1', 'Sí'].includes(value ?? '')) ? 'Sí' : 'No';
        }
        if (col.field === 'fecha_cad' && !moment(value, 'DD/MM/YYYY').isValid()) {
            return '-';
        }
        return value;
    }

    public add() {
        if (this.canEditTrabajadores) {
            if (this.filterAplicadoresByClient && !StorageManager.getClient() && this.userCanSeeClientes) {
                this.dashboard.openClientDialog();
            } else {
                this.router.navigate(['dashboard', 'crear-mantenimiento']);
            }
        }
    }

    public edit(data: MantenimientoModel) {
        if (this.canEditTrabajadores) {
            this.router.navigate(['dashboard', 'editar-mantenimiento', data.id]);
        }
    }

    public duplicate(data: MantenimientoModel) {
        if (this.canEditTrabajadores) {
            this.router.navigate(['dashboard', 'duplicar-mantenimiento', data.id]);
        }
    }

    public override deleteRegister() {
        if (this.canEditTrabajadores) {
            super.deleteRegister();
        }
    }

    public override show(modal: string, data: null | MantenimientoModel) {
        super.show(modal, data ?? {} as MantenimientoModel);
        this.setModalForm(modal);
    }

    public formChanges(model?: Partial<MantenimientoCargoFormModel>): void {
        if (!model) {
            return;
        }

        this.modelCargos = { ...this.modelCargos, ...model };
    }

    private initFilter(){
        if (this.appName === 'agropecuariaramirogruas'){
            this.propiedad.selected = 'Todos';
            this.filter.addFilter((copy: TreeNode<MantenimientoModel>[] | void) => (copy as TreeNode<MantenimientoModel>[]).filter(row => {
                const trabajador = row.data as MantenimientoModel;

                switch (this.propiedad.selected) {
                case 'Propios':
                    return trabajador.propiedad === 'Propios';
                case 'Cliente':
                    return trabajador.propiedad === 'Cliente';
                default:
                    return true;
                }// switch();
            }));
        }
        else if (this.appName === 'innovia'  && this.currentUser.rol === 'user'){
            this.filter.addFilter((data: TreeNode<MantenimientoModel>[] | void) => (data || [])
                .filter((it: TreeNode<MantenimientoModel>) => it)
                .filter((it: TreeNode<MantenimientoModel>) => this.currentUser.id_cliente === (it as MantenimientoModel).id_cliente)
            );
        }
        else if (this.activateREA){
            this.filter.addFilter((data: TreeNode<MantenimientoModel>[] | void) => (data || [])
            .filter((it: TreeNode<MantenimientoModel>) => it)
            .filter((it: TreeNode<MantenimientoModel>) => {
                if (StorageManager.getClient()?.id) {
                    return StorageManager.getClient()?.id.toString() === (it as MantenimientoModel).id_cliente?.toString() || 
                        (it as MantenimientoModel).id_comercio !== null && (it as MantenimientoModel).id_comercio?.toString() !== '0';
                }
                return true;
             }));
        };
    }
    private setModalForm(modal: string): void {
        if (modal !== 'info' && modal !== 'delete') {
            return;
        }

        const formType = modal === 'delete' ? FormType.DELETION : FormType.INFORMATIVE;

        this.form = new MantenimientoFormDefinition(formType, this.model);
    }

}
